export default "__VITE_ASSET__BcEpHCE___"